@import "../../messages-dynamic/suggestions/suggestions.scss";
@import "../../messages-dynamic/suggestions/suggestions-card/suggestions-card.scss";
@import "../../messages-dynamic/suggestions/suggestions-card-outro/suggestions-card-outro.scss";
@import "../../predefined/error-answer-fallback/error-answer-fallback";
@import "../../../conversational-search-partials/details-header/details-header.scss";
@import "../../predefined/follow-ups/follow-up-not-satisfied/follow-up-not-satisfied.scss";
@import "../../predefined/follow-ups/follow-up-satisfied/follow-up-satisfied.scss";
@import "../../predefined/not-detailed-answer/not-detailed-answer.scss";
@import "../../predefined/not-detailed-answer-fallback/not-detailed-answer-fallback.scss";
@import "../../messages-dynamic/product-hierarchy/product-hierarchy-wrapper.scss";
@import "../../messages-dynamic/suggestions/suggestions-wrapper/suggestions-wrapper.scss";

.conversational-search-messages-mediator {
  &__default-message {
    white-space: pre-line;
  }
}
